import { cn as s } from "../../../lib/utils.es.js";
import { headingVariants as _ } from "./Heading.variants.es.js";
import { jsx as E } from "react/jsx-runtime";
import { Slot as d } from "@radix-ui/react-slot";
var l = "h2", v = ({ as: r, children: a, size: o, color: m, weight: t, align: i, className: e, asChild: f, fontFamily: n, ...p }) => /* @__PURE__ */ E(f ? d : r || l, {
  className: s(_({
    size: o,
    fontFamily: n,
    weight: t,
    color: m,
    align: i
  }), e),
  ...p,
  children: a
});
export {
  v as default
};
